/**
 * This class represent the criterias that are usefull (or not) to do a search
 * everything is not usefull for the front-office but needed to answer back
 */
export class SearchCriteria {
  // -------------- Usefull for front-office  -------------- //

  /**
   * Id creator
   */
  private static idCount = 0;

  /**
   * Id of the criteria
   */
  id: number;

  // -------------- Usefull for back-office  -------------- //

  /**
   * If the criteria should be display (useless)
   */
  bDisplay: boolean;

  /**
   * if they are restrictions (like a select) for filters (useless)
   */
  bRestrictToSuggestedValues: boolean;

  /**
   * always criteria for criterias (useless)
   */
  sCategory: string;

  /**
   * Operator (< , <= ...) usefull to perform a request
   */
  sComparatorTrackingValue: string;

  /**
   * Libelle used to guide user for typing (useless)
   */
  sHelpI18n: string;

  /**
   * Libelle use for filters form (useless)
   */
  sLibI18n: string;

  /**
   * Name of the i18n format
   */
  sNameI18n: string;

  /**
   * Name of the criteria to request the back-office (useless)
   */
  sNameId: string;

  /**
   * Input Field Value
   */
  sCriteriaTrackingValue;

  /**
   * useless on front
   */
  sScope: string;

  /**
   * useless on front
   */
  sStorageName: string;

  /**
   * useless on front
   */
  sStorageType: string;

  /**
   * useless on front
   */
  sTypeData: string;

  constructor(bDisplay: boolean, bRestrictToSuggestedValues: boolean, sCategory: string,
              sHelpI18n: string, sLibI18n: string, sNameI18n: string,
              sNameId: string, sScope: string, sStorageName: string,
              sStorageType: string, sTypeData: string, sCriteriaTrackingValue: string) {
    this.sNameId = sNameId;
    this.bDisplay = bDisplay;
    this.bRestrictToSuggestedValues = bRestrictToSuggestedValues;
    this.sCategory = sCategory;
    this.sHelpI18n = sHelpI18n;
    this.sLibI18n = sLibI18n;
    this.sNameI18n = sNameI18n;
    this.sScope = sScope;
    this.sStorageName = sStorageName;
    this.sStorageType = sStorageType;
    this.sTypeData = sTypeData;
    this.sCriteriaTrackingValue = sCriteriaTrackingValue;
    this.id = SearchCriteria.idCount;
    SearchCriteria.idCount++;
  }

  /**
   * static for template use purposes, determine if a Search criteria is in charge of sendNumber Filter
   * Usefull for dynamic filters
   * @param {SearchCriteria} criteria - the SearchCriteria you want to inspect
   * @return {boolean}
   */
  public static criteriaIsSendNumber(criteria: SearchCriteria): boolean {
    return criteria.sNameId === 'serialSent';
  }
  public static criteriaIsERLId(criteria: SearchCriteria): boolean {
    return criteria.sNameId === 'erlID';
  }
  /**
   * static for template use purposes, determine if a Search criteria is in charge of DepositNumber Filter
   * Usefull for dynamic filters
   * @param {SearchCriteria} criteria - the SearchCriteria you want to inspect
   * @return {boolean}
   */
  public static criteriaIsDepositNumber(criteria: SearchCriteria): boolean {
    return criteria.sNameId === 'serialLotDepot';
  }

  /**
   * Deep comparison between two strings
   *
   * @param {string} st1 - first string to compare
   * @param {string} st2 - second string to compare
   * @return {boolean} - true if the strings are equals
   */
  public static fieldValuesAreEquals(st1: string, st2: string): boolean {

    if (!st1 && st2 === '') {
      return true;
    }
    else if (st1 === '' && !st2) {
      return true;
    }
    else {
      return st1 === st2;
    }
  }

  /**
   * Determine if two criterias are equals
   *
   * @param {SearchCriteria} criteria_1 - first SearchCriteria to compare
   * @param {SearchCriteria} criteria_2 - second SearchCriteria to compare
   * @return {boolean} - true if the SearchCriteria are equals
   */
  public static equals(criteria_1: SearchCriteria, criteria_2: SearchCriteria): boolean {

    if (criteria_1.bDisplay !== criteria_2.bDisplay) {
      return false;
    }
    else if (criteria_1.sComparatorTrackingValue !== criteria_2.sComparatorTrackingValue) {
      return false;
    }
    else if (criteria_1.bRestrictToSuggestedValues !== criteria_2.bRestrictToSuggestedValues) {
      return false;
    }
    else if (criteria_1.sCategory !== criteria_2.sCategory) {
      return false;
    }
    else if (criteria_1.sHelpI18n !== criteria_2.sHelpI18n) {
      return false;
    }
    else if (criteria_1.sLibI18n !== criteria_2.sLibI18n) {
      return false;
    }
    else if (criteria_1.sNameI18n !== criteria_2.sNameI18n) {
      return false;
    }
    else if (criteria_1.sNameId !== criteria_2.sNameId) {
      return false;
    }
    else if (criteria_1.sScope !== criteria_2.sScope) {
      return false;
    }
    else if (criteria_1.sStorageName !== criteria_2.sStorageName) {
      return false;
    }
    else if (criteria_1.sStorageType !== criteria_2.sStorageType) {
      return false;
    }
    else if (criteria_1.sTypeData !== criteria_2.sTypeData) {
      return false;
    }
    else if (!this.fieldValuesAreEquals(criteria_1.sCriteriaTrackingValue, criteria_2.sCriteriaTrackingValue)) {
      return false;
    }

    return true;
  }
}
